import React from "react";
import "./App.css";
import { Routes, Route } from "react-router-dom";
import { Header } from "./components/Header";
import { Hero } from "./components/Hero";
import { AboutBook } from "./components/AboutBook";
import { Chapters } from "./components/Chapters";
import { Preface } from "./components/Preface";
import { AboutAuthor } from "./components/AboutAuthor";
import { WhyIWrote } from "./components/WhyIWrote";
import { Quote } from "./components/Quote";
import { BookExcerpts } from "./components/BookExcerpts";
import { Reviews } from "./components/Reviews";
import { Presentations } from "./components/Presentations";
import { Gallery } from "./components/Gallery";
import { Purchase } from "./components/Purchase";
import { ContactForm } from "./components/ContactForm";
import { Footer } from "./components/Footer";
import { Toaster } from "./components/ui/sonner";
import { BiografiaCompleta } from "./pages/BiografiaCompleta";

const HomePage = () => (
  <>
    <Header />
    <main>
      <Hero />
      <AboutBook />
      <Preface />
      <Chapters />
      <AboutAuthor />
      <WhyIWrote />
      <Quote />
      <BookExcerpts />
      <Presentations />
      <Reviews />
      <Gallery />
      <Purchase />
      <ContactForm />
    </main>
    <Footer />
  </>
);

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/biografia-completa" element={<BiografiaCompleta />} />
      </Routes>
      <Toaster />
    </div>
  );
}

export default App;
